// extracted by mini-css-extract-plugin
module.exports = {"login-main-container":"LoginForm_login-main-container__2DXNX","login-container":"LoginForm_login-container__1v4Xn","form-input":"LoginForm_form-input__3HvKN"};